import { render, staticRenderFns } from "./LTILaunch.vue?vue&type=template&id=3fa548b6&"
import script from "./LTILaunch.vue?vue&type=script&lang=js&"
export * from "./LTILaunch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3fa548b6')) {
      api.createRecord('3fa548b6', component.options)
    } else {
      api.reload('3fa548b6', component.options)
    }
    module.hot.accept("./LTILaunch.vue?vue&type=template&id=3fa548b6&", function () {
      api.rerender('3fa548b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/LTILaunch.vue"
export default component.exports